module.exports = __webpack_public_path__ + "components/country-flag/static/cx-f7d005bcf5d939c7a101b794b93ea0ef.svg";